import { createActions, createReducer } from "../../helpers/Redux";
import initialState from "../models/deviceClockIn";

const { actions, types } = createActions({
  requestFetchDevice: ["id"],
  fetchDeviceSucceeded: ["device"],
  fetchDeviceFailed: ["error"],

  requestDeviceCheckIfClockedIn: null,
  checkIfDeviceClockedInSucceeded: ["shift"],
  checkIfDeviceClockedInFailed: ["error"],

  requestDeviceClockIn: ["onSuccess"],
  clockInDeviceSucceeded: ["shift"],
  clockInDeviceFailed: ["error"],

  requestDeviceClockOut: ["onSuccess"],
  clockOutDeviceSucceeded: null,
  clockOutDeviceFailed: ["error"],
});

const reducer = createReducer(initialState, {
  [types.REQUEST_FETCH_DEVICE]: (state) => ({
    ...state,
    isFetchingDevice: true,
    device: null,
    fetchingDeviceError: null,
  }),
  [types.FETCH_DEVICE_SUCCEEDED]: (state, { payload: { device } }) => ({
    ...state,
    isFetchingDevice: false,
    device,
  }),
  [types.FETCH_DEVICE_FAILED]: (state, { payload: { error } }) => ({
    ...state,
    isFetchingDevice: false,
    fetchingDeviceError: error,
  }),
  [types.REQUEST_DEVICE_CHECK_IF_CLOCKED_IN]: (state) => ({
    ...state,
    isCheckingIfClockedIn: true,
    checkingIfClockedInError: null,
    isClockedIn: false,
    shift: null,
  }),
  [types.CHECK_IF_DEVICE_CLOCKED_IN_SUCCEEDED]: (state, { payload: { shift } }) => ({
    ...state,
    isCheckingIfClockedIn: false,
    isClockedIn: true,
    shift,
  }),
  [types.CHECK_IF_DEVICE_CLOCKED_IN_FAILED]: (state, { payload: { error } }) => ({
    ...state,
    isCheckingIfClockedIn: false,
    checkingIfClockedInError: error,
  }),

  [types.REQUEST_DEVICE_CLOCK_IN]: (state) => ({
    ...state,
    isClockedIn: false,
    isClockingIn: true,
    clockingInError: null,
    shift: null,
  }),
  [types.CLOCK_IN_DEVICE_SUCCEEDED]: (state, { payload: { shift } }) => ({
    ...state,
    isClockedIn: true,
    isClockingIn: false,
    shift,
  }),
  [types.CLOCK_IN_DEVICE_FAILED]: (state, { payload: { error } }) => ({
    ...state,
    isClockingIn: false,
    clockingInError: error,
  }),

  [types.REQUEST_DEVICE_CLOCK_OUT]: (state) => ({
    ...state,
    isClockingOut: true,
    clockingOutError: null,
  }),
  [types.CLOCK_OUT_DEVICE_SUCCEEDED]: (state) => ({
    ...state,
    isClockedIn: false,
    isClockingOut: false,
    shift: null,
  }),
  [types.CLOCK_OUT_DEVICE_FAILED]: (state, { payload: { error } }) => ({
    ...state,
    isClockingOut: false,
    clockingOutError: error,
  }),
});

export { reducer as default, types, actions };
